import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { WithContext as ReactTags } from 'react-tag-input';
import { Button } from 'react-bootstrap';
import ModalComponent from '../../Layout/Modal';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import { RULESMESSAGE, areaCode } from '../../../_constants';
import Header from '../../Inc/Layout/Header.js';
import Footer from '../../Inc/Layout/Footer.js';
import Chat from '../../Chat/Chat.js';
import JobList from '../../Job/JobList.js';
import ResumeList from './ResumeList.js';
import SubUser from '../../SubUser/SubUser.js';
import SubUserAdd from '../../SubUser/SubUserAdd.js';
import { uploadResumeFile, getAllCityAction } from '../../../actions/FindRecCompany';
import { getAllHome } from '../../../actions/home';
import { getProfileAction, deactivateAccountAction, updateProfileAction, checkUserUrlLink, updateUserUrlLink } from '../../../actions/Profile';
import { notification } from 'antd';
import $ from 'jquery';
import loadingImage from "../../loadingImageRc.gif";
import '../../../../public/index.css';
import Auth from '../../Auth/auth';
const auth = new Auth();

let Validator = require('validatorjs');
let styleData = { color: "red" }
let formArr = {};
let rules = {
    field: 'required',
    companyAddress: 'required'
};

let validation = [];
validation = new Validator([], rules, RULESMESSAGE);
validation.passes();
validation.fails();

let className = "";
let fieldsArr = []
const KeyCodes = {
    comma: 188,
    enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];
var a = 0;

class JobProviderProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabTypeShow: "tab",
            fieldsList: [],
            fieldOption: [],
            tags: [],
            tagvalue: [],
            cityOption: [],
            allCityData: [],
            formArr: [],
            suggestions: [],
            imageUpload: false,
            refreshButton: false,
            viewAllModal: false,
            editprofileModal: false,
            request: true,
            disabled: false,
            requestServer: true,
            requestCategory: false,
            deleteConfirmModal: false,
            addSubUserModal: false,
            urlLinkStatus: true,
            deleteConfmModalAccount: false,
            ProfileDetail: {phoneExt:"+1"},
            userData: JSON.parse(localStorage.getItem('userData'))
        }
    }

    componentWillMount() {
        let reqObj = {
            "limit": 100,
            "offset": 0,
            "order": "name",
            "direction": "desc",
            "search": "",
            "status": ""
        }
        this.setState({
            requestCategory:true
        })
        this.props.getAllHome(reqObj);
    }

    componentDidMount() {
        
        this.props.getAllCityAction();
        const location = this.props 

         if(location.location&&location.location.redirectFor === "job"){
            this.setState({
                tabTypeShow: "tabTwoB"
            })
            $(".tab-pane").removeClass("active")
            $("a").removeClass("active")
            $("#tabTwoB").addClass("active")
            $("#btntabTwoB").addClass("active")
         }

         if(location.location&&location.location.redirectFor === "resumeList"){
            this.setState({
                tabTypeShow: "tabThree"
            })
            $(".tab-pane").removeClass("active")
            $("a").removeClass("active")
            $("#tabThree").addClass("active")
            $("#btntabThree").addClass("active")
         }
        //this.props.getProfileAction();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.fields && nextProps.fields.length > 0 && this.state.requestCategory) {
            var fieldsList = nextProps.fields;
            var option = [];
            for (var i in nextProps.fields) {
                let obj = {
                    value: fieldsList[i]._id,
                    label: fieldsList[i].name
                }
                option.push(obj);
            }
            this.setState({
                request: true,
                requestCategory: false,
                fieldsList: nextProps.fields,
                fieldOption: option
            },function(){
                this.profile();
            })
        }
        
        const location = this.props && this.props.history && this.props.history.location;
        const state = location.state
        if(state){
            const chatSectionModule = state.chatSectionModule
            if (chatSectionModule) {
                this.setState({
                    tabTypeShow: "tabFour"
                })
                $(".tab-pane").removeClass("active")
                $("a").removeClass("active")
                $("#tabFour").addClass("active")
                $("#btntabFour").addClass("active")
            } 
        }
        const { imageUpload } = this.state
        switch (nextProps.detailTypa) {
            case "getData":
                if (nextProps.ProfileDetail && nextProps.ProfileDetail.statusCode === 200 && this.state.request) {
                    var specializations = nextProps.ProfileDetail.data.specializations
                    var profileDetailData = nextProps.ProfileDetail.data;
                    localStorage.setItem('userData', JSON.stringify(profileDetailData))
                    let tags = this.state.tags
                    if (specializations.length > 0) {
                        tags = [];
                        for (var x in specializations) {
                            tags.push({ id: specializations[x], text: specializations[x] })
                        }
                    }else{
                        tags = [];
                    }
                    if (nextProps.ProfileDetail.data && nextProps.ProfileDetail.data.categoryId && nextProps.ProfileDetail.data.categoryId.length > 0) {
                        var categoryId = profileDetailData.categoryId;
                        var fieldOption = this.state.fieldOption
                        profileDetailData["field"] = [];
                        for (var y in fieldOption) {
                            var index = categoryId.indexOf(fieldOption[y].value)
                            if (index !== -1) {
                                profileDetailData["field"].push(fieldOption[y])
                            }
                        }
                    }
                    // if(profileDetailData.phoneExt){
                    //    profileDetailData.areaCode = areaCode.find(item=>item.value ==profileDetailData.phoneExt);
                    // }
                    localStorage.setItem('userData', JSON.stringify(profileDetailData))
                  
                    this.setState({
                        ProfileDetail: profileDetailData,
                        tags: tags,
                        disabled: true,
                        requestServer: false,
                        request: false
                    });
                }
                break;
            case "updateData":
                let _this = this;
                if (nextProps.ProfileDetail.statusCode === 200) {
                    _this.setState({ editprofileModal: false });
                    notification.success({
                        message: nextProps.ProfileDetail.msg,
                        className:'successNotification',
                        duration: 3
                    });
                    this.setState({
                        request:true
                    }, () => {
                        this.profile();
                    })
                }
                break;
            case "deactiveAccount":
                if (nextProps.ProfileDetail.statusCode === 200) {
                    notification.success({
                        message: "You'r ACcount Deactivated successfully",
                        className:'successNotification',
                        duration: 3
                    });
                    localStorage.removeItem('userLogin')
                    localStorage.removeItem('userData')
                    this.props.history.push({
                        pathname: "/"
                    });
                    window.location.reload();
                }
                break;
            case "checkUrl":
                if (nextProps.ProfileDetail.statusCode === 200 && nextProps.ProfileDetail.data) {
                   this.setState({
                       urlLinkStatus: nextProps.ProfileDetail.data.length == 0 ? true:false,
                       disabled: nextProps.ProfileDetail.data.length == 0 ? false:true,

                   })
                }
                break;
            case "updateUrl":
                if (nextProps.ProfileDetail.statusCode === 200 && nextProps.ProfileDetail.data) {
                    notification.success({
                        message: "Updated successfully",
                        className:'successNotification',
                        duration: 3
                    });
                    this.setState({
                        requestServer: false,
                        request: false
                    });
                   // this.setState({
                   //     urlLinkStatus: nextProps.ProfileDetail.data.length == 0 ? true:false
                   // })
                }
                break;
            default:
                return true;
        }

        if (nextProps.image && nextProps.image.statusCode && nextProps.image.statusCode === 200 && imageUpload) {
            this.setState({
                imageUpload: false
            })
            var userDetail = this.state.ProfileDetail
            userDetail['image'] = nextProps.image.file_name;
            this.props.updateProfileAction(userDetail)
        }

        if (nextProps.setCityB && Array.isArray(nextProps.setCityB)) {
            let ProfileDetail = this.state.ProfileDetail
            ProfileDetail["companyAddress"] = nextProps.setCityB;
            this.setState({
                ProfileDetail: ProfileDetail
            });
        }

        if (nextProps.setCity && Array.isArray(nextProps.setCity)) {
            let ProfileDetail = this.state.ProfileDetail
            ProfileDetail["city"] = nextProps.setCity;
            this.setState({
                ProfileDetail: ProfileDetail
            });
        }

        if (nextProps.allCitySuggetion && nextProps.allCitySuggetion.statusCode === 200) {
            let cityData = (nextProps.allCitySuggetion.cityData && nextProps.allCitySuggetion.cityData.data) ? nextProps.allCitySuggetion.cityData.data : [];
            let cityArr = [];
            for (var k in cityData) {
                let obj = {};
                obj.label = cityData[k].cityName;
                obj.city = cityData[k].cityName;
                obj.value = cityData[k]._id;
                obj.state = cityData[k].stateId;
                obj.state = cityData[k].stateName;
                obj.country = cityData[k].countryName;
                obj.zipCode = "";
                obj.countryId = cityData[k].countryId;
                obj.address = cityData[k].cityName;
                obj.coordinates = cityData[k].coordinates;
                cityArr.push(obj);
            }

            this.setState({
                cityOption: cityArr
            })
        }
    }

    handleChangeradioForRadio = (value, e) => {
        let ProfileDetail = this.state.ProfileDetail;
        ProfileDetail.messageEmailNotification = value;
        this.setState({
            disabled: false,
            ProfileDetail: ProfileDetail
        })
    }

    deleteConfmModalAccount = () => {
        this.setState({
            deleteConfmModalAccount: !this.state.deleteConfmModalAccount
        })
    }

    addSubUser = () => {
        this.setState({
            addSubUserModal: !this.state.addSubUserModal
        })
    }

    deleteAccountOk = (data) => {
        this.props.deactivateAccountAction()
    }

    profile = (name, value) => {
        this.props.getProfileAction();
    }

    editProfile = () => {
        this.setState({ disabled: false });
    }

    cancelProfile = () => {
        this.profile();
        this.setState({ request: true, disabled: true , urlLinkStatus:true});
    }

    upDateProfile = () => {
        if (this.allValidate(false)) {
            let ProfileDetail = this.state.ProfileDetail;
            let tags = this.state.tags;
            ProfileDetail.specializations = [];
            for (var x in tags) {
                ProfileDetail.specializations.push(tags[x].text)
            }
            this.setState({
                request: true,
                requestServer: true
            })
            this.props.updateProfileAction(ProfileDetail)
        }
    }

    updateUserUrl = () => {
        if(this.state.urlLinkStatus){
            this.setState({
                request: true,
                requestServer: true
            })
            // this.state.formData
            this.props.updateUserUrlLink({userUrlLink: this.state.ProfileDetail.userUrlLink})
        }        
    }

    myFunction = () => {
        var dots = document.getElementById("dots");
        var moreText = document.getElementById("more");
        var btnText = document.getElementById("myBtn");
        if (dots.style.display === "none") {
            dots.style.display = "inline";
            btnText.innerHTML = "Read more";
            moreText.style.display = "none";
        } else {
            dots.style.display = "none";
            btnText.innerHTML = "Read less";
            moreText.style.display = "inline";
        }
    }

    fields() {
        fieldsArr = [];
        const { fieldsList } = this.state
        var i = 0;
        for (i in fieldsList) {
            fieldsArr.push(<div className="col-md-6"><input type="checkBox" name="fields" id={fieldsList[i]._id} value={fieldsList[i]._id} onChange={this.handleChangeRadio} />{fieldsList[i].name}</div>)
        }
    }

    handleDelete = (i) => {
        const { tags, tagvalue } = this.state;
        this.setState({
            tags: tags.filter((tag, index) => index !== i),
            tagvalue: tagvalue.filter((tagvalue, index) => index !== i),
            disabled: false,
        });
    }

    handleDrag = (tag, currPos, newPos) => {
        const tags = [...this.state.tags];
        const newTags = tags.slice();
        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);
        this.setState({ tags: newTags ,disabled: false});
    }

    handleAddition = (tag) => {
        var tagvalue = tag.text;
        this.setState(state => ({ tags: [...state.tags, tag] }));
        this.setState(state => ({ tagvalue: [...state.tagvalue, tagvalue], disabled: false}));
    }

    handleChange = e => {
        e.preventDefault();
        let { ProfileDetail } = this.state;
         let value = e.target.value;
        if (e.target.name === 'phone' || e.target.name === 'additionalContact') {
            var n = e.target.value;
            //value = null;
            if( n.length < 11){
                value = n.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
                value = parseInt(value, 10);
            }else{
                value = ProfileDetail[e.target.name];
            }
        }
        ProfileDetail[e.target.name] = value;
        this.setState({ ProfileDetail: ProfileDetail,disabled: false });
    };

    handleChangeUserLink = e => {
        e.preventDefault();
        let { ProfileDetail } = this.state;
        let value = (e.target.value).replace(/\s/g,'');
            ProfileDetail[e.target.name] = value.toLowerCase();
        this.setState({ ProfileDetail: ProfileDetail, refreshButton:true, disabled:value == "" ? true: false});
        if(value !== ""){
            this.props.checkUserUrlLink({userUrlLink:value})
        }
        
    };

    handleChangeSelect = (name, value) => {
        let ProfileDetail = this.state.ProfileDetail
        ProfileDetail["categoryId"] = [];
        ProfileDetail[name] = value
        for (var i in value) {
            ProfileDetail["categoryId"].push(value[i].value);
        }
        this.setState({
            disabled: false,
            ProfileDetail: ProfileDetail
        });
    }

    handleChangeSelectCity = (name, value) => {
        let ProfileDetail = this.state.ProfileDetail
        ProfileDetail.companyAddress = value;

        // ProfileDetail[name] = value
        // for (var i in value) {
        // ProfileDetail["categoryId"].push(value[i].value);
        // }
        this.setState({
            ProfileDetail: ProfileDetail,
            disabled: false
        });
    }

    handleChangeSelectPhone = (name, value) => {
        let ProfileDetail = this.state.ProfileDetail
        ProfileDetail["areaCode"] = value
        ProfileDetail[name] = value.value
        this.setState({
            ProfileDetail: ProfileDetail
        });
    }

    viewAllOption = (type, e) => {
        if (!this.state.viewAllModal) {
            this.resumeList();
        }
        this.setState({
            viewAllModal: !this.state.viewAllModal
        });
    }

    onError(e) {
        // console.log(e, 'error in file-viewer');
    }

    showImage(resumeImage) {
        if (resumeImage) {
            let fileUrl = process.env.REACT_APP_SERVER_IMAGE_BUCKET + "/" + resumeImage;
            return fileUrl;
        } else {
            return <span>-</span>
        }
    }

    handleTab = (type, e) => {
        this.setState({
            tabTypeShow: type
        })
        $(".tab-pane").removeClass("active")
        $("a").removeClass("active")
        $("#" + type).addClass("active")
        $("#btn" + type).addClass("active")
    }

    changeImage = (e) => {
        e.preventDefault();
        this.setState({
            imageUpload: true
        })
        var file = document.getElementById("file").files[0];
        this.props.uploadResumeFile(file)
    }

    allValidate(check) {
        if (!check) {
            formArr = []
            Object.keys(rules).forEach(function(key) {
                formArr[key] = "TT";
            });
            this.setState({
                formArr
            });
        }
        if (validation.passes()) {
            return 1;
        }
    }

    render() {
        let { requestServer, ProfileDetail, fieldOption, suggestions, tags, cityOption, userData, refreshButton } = this.state
        let deleteConfirmModalBody = <div className="user-section">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h6>Are You Sure You Want Deactivate Your Account!</h6>
                                            </div>
                                        </div>
                                    </div>

        let deleteConfirmModalFooter = <div>
                                            <Button className="cnf-btn update-btn" onClick={this.deleteAccountOk}>Confirm</Button>
                                            <Button type="cancel" onClick={this.deleteConfmModalAccount}>Cancel</Button>                       
                                        </div>

        validation = new Validator(ProfileDetail, rules, RULESMESSAGE);
        validation.passes();
        validation.fails();

        if (requestServer) {
            className = "pageloading";
        } else {
            className = "";
        }

        let shortBio = "";
        if (ProfileDetail.shortBio !== undefined) {
            shortBio = ProfileDetail.shortBio
            let text1 = shortBio;
            let text2 = "";
            if (shortBio.length > 100) {
                text1 = shortBio.substr(0, 1000);
                text2 = shortBio.substr(100, shortBio.length);
                shortBio =
                    <span className="bio-text">
                        <div className="bio-text">{text1}<span id="dots">...</span><span id="more">{text2}</span></div>
                        <span onClick={this.myFunction} id="myBtn" className="readMore-btn"><a>Read more</a></span>
                    </span>
            } else {
                shortBio =
                    <span className="bio-text">{text1}</span>
            }
        }

        return (
            <div>
                <div className={"pageForLoading "+className}>
                   <div className="wrap">
                        <div className="loading">
                            <img src={loadingImage} alt="Loading" />
                        </div>
                    </div>
                </div>

                <div className="all-page-wrapper">
                    <Header props={this.props } />
                    <div className="page-wrapper">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="profile-sidebar">
                                        <ul>    
                                            <li><a  className="active" id="btntab" onClick={this.handleTab.bind(this,"tab")} data-toggle="tab" >My Account</a></li>
                                            <li><a data-toggle="tab" id="btntabTwoB" onClick={this.handleTab.bind(this,"tabTwoB")} >Job</a></li>
                                            <li><a data-toggle="tab" id="btntabThree" onClick={this.handleTab.bind(this,"tabThree")} >History</a></li>
                                            {userData.userType !== "subUser" &&
                                                <span>
                                                    <li><a data-toggle="tab" id="btntabFour" onClick={this.handleTab.bind(this,"tabFour")}>Message</a></li>
                                                {userData.userType !== "recruiter" && 
                                                    <li><a data-toggle="tab" id="btntabFive" onClick={this.handleTab.bind(this,"tabFive")}>Recruiter</a></li>
                                                }
                                                </span>
                                            }
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-9">
                                    <div className="profile-rightbar profile-content">
                                        <div className="tab-pane myaccount active" id="tab">
                                            <div className="profile-title">
                                                <h3 className="ac-head">My Account</h3>
                                                <div className="approved-sts">
                                                    {ProfileDetail.approvedStatus==="approve" &&
                                                        <div className="check-btn"><i className="fa fa-check"></i> Approved</div>
                                                    }
                                                    {ProfileDetail.approvedStatus==="unapprove" &&
                                                        <div className="cross-btn"><i className="fa fa-clock-o"></i> Approval Pending</div>
                                                    }
                                                    {ProfileDetail.approvedStatus==="block" &&
                                                        <div className="block-btn"><i className="fa fa-ban"></i> Blocked</div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="user-section">
                                                <div className="user-image-block">
                                                    <div className="img-circular">
                                                        <img src={ProfileDetail.image?this.showImage(ProfileDetail.image):"https://www.pngfind.com/pngs/m/535-5357481_user-account-management-circle-user-icon-blue-hd.png"} alt="new" className="rounded" scale={4} vertical={0} horizontal={5} />
                                                    </div>
                                                    <div className="img-edit">
                                                        <input type="button" className="edit-text" id="loadFile" value="Change image" onClick="document.getElementById('file').click();" />
                                                        <input type="file" className="box__file" id="file" name="files" onChange={this.changeImage.bind(this)} accept="image" required />
                                                    </div>
                                                </div>
                                                <div className="user-block">
                                                    <h4 className="user-name">{ProfileDetail.firstName}</h4>
                                                    <h5 className="user-type">{ProfileDetail.userType}</h5>
                                                </div>
                                                {/*<div className="editbtn-block">
                                                    <a className="editBtn" onClick={this.editProfile}><i className="fa fa-pencil" aria-hidden="true"></i></a>
                                                </div>*/}
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <div className="row">
                                                            <div className="bg-signup col-md-12">
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <div className="form-group">
                                                                            <label className="pf-label">Name<span>*</span></label>
                                                                            <input type="text" className="form-control singup-control" name="firstName" onChange={this.handleChange} placeholder="" value={ProfileDetail.firstName} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <div className="form-group">
                                                                            <label className="pf-label">Email<span>*</span></label>
                                                                            <input type="text" className="form-control singup-control" name="email" onChange={this.handleChange} placeholder="" value={ProfileDetail.email} disabled={true} />
                                                                        </div>
                                                                    </div>
                                                                    {/*<div  className="col-md-2">
                                                                        <div className="form-group">
                                                                            <label className="pf-label">Area Code</label>
                                                                            <Select name="phoneExt" className="singup-control" closeMenuOnSelect={false} components={makeAnimated()} value={ProfileDetail.areaCode  } onChange={this.handleChangeSelectPhone.bind(this, "phoneExt" )} options={areaCode}  placeholder="Select Phone ext." />
                                                                        </div>
                                                                    </div>*/}
                                                                    <div  className="col-md-4">
                                                                        <div className="form-group">
                                                                            <label className="pf-label">Phone Number<span></span></label>
                                                                            <input type="text" className="form-control singup-control" name="phone" onChange={this.handleChange} placeholder="Phone Number" value={ProfileDetail.phone}  />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-2"></div>
                                                                    <div  className="col-md-4">
                                                                        <div className="form-group">
                                                                            <label className="pf-label">Url Link<span></span></label>
                                                                            <input type="text" className="form-control singup-control" name="userUrlLink" onChange={this.handleChangeUserLink} placeholder="Url link" value={ProfileDetail.userUrlLink}  />
                                                                        </div>
                                                                        {!this.state.urlLinkStatus &&
                                                                          <span className="error">Allready exists.</span>
                                                                        }
                                                                        {ProfileDetail.userUrlLink == "" &&
                                                                          <span className="error">This field is required.</span>
                                                                        }
                                                                    </div>
                                                                    <div className="col-md-2">
                                                                    <label className="pf-label"><span></span></label>
                                                                    {/*refreshButton &&
                                                                        <Button className="save-btn update-btn resetButton" onClick={this.cancelProfile} ><i class="fa fa-refresh" aria-hidden="true"></i> &nbsp;</Button>
                                                                    */}
                                                                    </div>
                                                                </div>
                                                                {userData.userType !=="subUser" &&
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <div className="form-group">
                                                                                <label className="pf-label">Short-Bio<span>*</span></label>
                                                                                <textarea type="text" rows="4" className="form-control singup-control" name="shortBio" onChange={this.handleChange} placeholder="" value={ProfileDetail.shortBio}></textarea>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-12">
                                                                            <div className="form-group">
                                                                                <label className="pf-label">Category<span>*</span></label>
                                                                                <Select name="field" className="singup-control" isMulti closeMenuOnSelect={false} components={makeAnimated()} value={ProfileDetail.field} onChange={this.handleChangeSelect.bind(this, "field" )} options={fieldOption} disabled={true} placeholder="Select Category" />
                                                                            </div>
                                                                            <span style={styleData} className="error">{this.state.formArr.field && validation.errors.first('field')}</span>
                                                                        </div>
                                                                    </div>
                                                                 }
                                                                <div className="row">
                                                                    {(ProfileDetail.userType==="recruiter")&&
                                                                    <div className="col-md-12 custom-field">
                                                                        <div className="form-group">
                                                                            <label className="pf-label">Speciality</label>
                                                                            <ReactTags className="serach-Box in-custom-control" tags={tags} suggestions={suggestions} handleDelete={this.handleDelete} handleAddition={this.handleAddition} handleDrag={this.handleDrag} delimiters={delimiters} disabled={true} />
                                                                        </div>
                                                                    </div>
                                                                    }
                                                                </div>
                                                                <div className="row">
                                                                    {userData.userType !=="subUser" &&
                                                                        <div className="col-md-12">
                                                                            <div className="form-group">
                                                                                <label className="pf-label" htmlFor="city"> City </label>
                                                                                <Select name="city" className="singup-control" isMulti closeMenuOnSelect={false} components={makeAnimated()} value={ProfileDetail.companyAddress} onChange={this.handleChangeSelectCity.bind(this, "city" )} options={cityOption} disabled={true} placeholder="Select City" />
                                                                                <span style={styleData} className="error">{this.state.formArr.companyAddress && validation.errors.first('companyAddress')}</span>
                                                                                
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    <div className="col-md-12">
                                                                        <div className="form-group new-radio-block">
                                                                            <label className="pf-label" htmlFor="city">Do you want to receive email notification for any communication through arightconnection</label>
                                                                            <span className="radio-signups">
                                                                                <input type="radio" className="new-radio-btn" name="radioNotificatio" onChange={this.handleChangeradioForRadio.bind(this,true)} id="yesNotification" checked={ProfileDetail.messageEmailNotification===true} /><label className="cus-radio-label" htmlFor="yesNotification">Yes</label>
                                                                                <input type="radio" className="new-radio-btn" name="radioNotificatio" onChange={this.handleChangeradioForRadio.bind(this,false)} id="noNotification" checked={ProfileDetail.messageEmailNotification===false} /><label className="cus-radio-label" htmlFor="noNotification">No</label>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    {!this.state.disabled &&
                                                                        <div className="col-md-12">
                                                                            <div className="button-block">
                                                                                <Button className="save-btn update-btn" onClick={this.upDateProfile} disabled={this.state.disabled}>Update</Button>
                                                                                <Button className="cancel-btn" onClick={this.cancelProfile}>Cancel</Button>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    <div className="col-md-12">
                                                                    </div>
                                                                        {/*<div  className="col-md-4">
                                                                            <div className="form-group">
                                                                                <label className="pf-label">Url Link<span></span></label>
                                                                                <input type="text" className="form-control singup-control" name="userUrlLink" onChange={this.handleChangeUserLink} placeholder="Url link" value={ProfileDetail.userUrlLink}  />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-3"><br/><br/>
                                                                            <Button className="save-btn update-btn" onClick={this.cancelProfile} >Reset</Button>&nbsp;
                                                                            <Button className="save-btn update-btn" onClick={this.updateUserUrl} disabled={!this.state.urlLinkStatus}>Update</Button>
                                                                        </div>*/}
                                                                        <div className="col-md-2">
                                                                        </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/*<div className="profile-border"></div>*/}
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="deactive-bb">
                                                        <span onClick={this.deleteConfmModalAccount}>Deactivate Account</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                       
                                        <div className="tab-pane history" id="tabTwoB">
                                        {this.state.tabTypeShow ==="tabTwoB" &&
                                            <JobList auth={auth} categoryOption={fieldOption} cityOption={cityOption}/>
                                        }
                                        </div>                                      
                                        <div className="tab-pane history" id="tabThree">
                                        {this.state.tabTypeShow ==="tabThree" &&
                                            <ResumeList />
                                        }
                                        </div>

                                        <div className="tab-pane history" id="tabFour">
                                            <div className="history-block">
                                                <h3 className="ac-head">Message</h3>
                                                <div className="resume-history">
                                                    <div className="status-content">
                                                        <div className="status-content">
                                                        {this.state.tabTypeShow ==="tabFour" &&
                                                            <Chat />
                                                        }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                        

                                        <div className="tab-pane history" id="tabFive">
                                            {this.state.tabTypeShow ==="tabFive" &&
                                                <SubUser auth={auth} categoryOption={fieldOption} cityOption={cityOption}  />
                                            }
                                        </div>
                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                        <SubUserAdd auth={auth} categoryOption={fieldOption} cityOption={cityOption} isOpen={this.state.addSubUserModal} action={this.addSubUser} />
                        <ModalComponent title={"Deactivate Account!"} modalState={this.state.deleteConfmModalAccount}  modalBody={deleteConfirmModalBody}  FooterVl={deleteConfirmModalFooter} action={this.deleteConfmModalAccount} />
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        detailTypa: state.Profile.type,
        ProfileDeta: state.Profile,
        ProfileDetail: state.Profile.response,
        fields: state.home.response.data,
        allCitySuggetion: state.FindRecCompany.allCitySuggetion,
        image: state.FindRecCompany.resume,
        setCity: state.FindRecCompany.setCity,
        setCityB: state.FindRecCompany.setCityB
    };
}
export default withRouter(connect(mapStateToProps, {
    getAllHome,
    getProfileAction,
    uploadResumeFile,
    deactivateAccountAction,
    getAllCityAction,
    updateProfileAction,
    updateUserUrlLink,
    checkUserUrlLink
})(JobProviderProfile));


// WEBPACK FOOTER //
// ./src/components/JobProvider/Profile/JobProviderProfile.js